/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AutoTestStepBaseInputAsJSON } from './AutoTestStepBaseInputAsJSON';
import { CheckPointsExtra } from './CheckPointsExtra';
const CheckPointsInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(CheckPointsExtra, AutoTestStepBaseInputAsJSON);
export class CheckPointsInputAsJSON extends AutoTestStepBaseInputAsJSON {
    static decode(input) {
        return CheckPointsInputAsJSONParser.decode(input).map(res => new CheckPointsInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return CheckPointsInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CheckPointsInputAsJSONParser.encode(data);
    }
    static schema() {
        return CheckPointsInputAsJSONParser.schema();
    }
}
